export default "__VITE_ASSET__OyyDaNAu__"